import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TableColumn } from '../models/table-column.models';
import { Filter } from '../models/filter.models';

@Component({
  selector: 'cms-table',
  templateUrl: './cms-table.component.html',
  styleUrls: ['./cms-table.component.scss'],
})
export class CmsTableComponent implements OnInit, AfterViewInit {
  public tableDataSource = new MatTableDataSource<any[]>([]);
  public displayedColumns: string[] = [];
  public panelOpenState = false;
  @ViewChild(MatPaginator, {static: false}) matPaginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) matSort: MatSort;

  @Input() isPageable = false;
  @Input() isSortable = false;
  @Input() isFilterable = false;
  @Input() isExportExcel = false;
  @Input() tableColumns: TableColumn[] =[];
  @Input() filters: Filter[] = [];
  @Input() paginationSizes: number[] = [50,100, 200, 500];
  @Input() defaultPageSize = this.paginationSizes[1];
  @Input() totalRows = 0;
  @Input() currentPage = 0;


  @Output() sort: EventEmitter<Sort> = new EventEmitter();
  @Output() cellAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() rowAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() pageChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() filter: EventEmitter<any> = new EventEmitter<any>();
  @Output() exportExcel: EventEmitter<any> = new EventEmitter<any>();
  @Output() queryParamFilter: EventEmitter<any> = new EventEmitter<any>();

  // this property needs to have a setter, to dynamically get changes from parent component
    @Input() set tableData(data: any[]) {
      this.setTableDataSource(data);
    }


  constructor(


  ) {}


   // we need this, in order to make pagination work with *ngIf
   ngAfterViewInit(): void {
    this.tableDataSource.paginator = this.matPaginator;
  }

  ngOnInit(): void {
      this.displayedColumns = this.tableColumns.map((tableColumn: TableColumn) => tableColumn.name);
  }

  setTableDataSource(data: any) {
    this.tableDataSource = new MatTableDataSource<any>(data);
    //this.tableDataSource.paginator = this.matPaginator;
    //this.tableDataSource.sort = this.matSort;
  }

  //FRONTEND SEARCH
  // applyFilter(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.tableDataSource.filter = filterValue.trim().toLowerCase();
  // }

  sortTable(sortParameters: Sort) {
    // defining name of data property, to sort by, instead of column name
    sortParameters.active = this.tableColumns.find(column => column.name === sortParameters.active)?.sortKey || "";
    this.sort.emit(sortParameters);
    this.matPaginator.firstPage();
  }

  emitCellAction(key: any, value: any) {
    this.cellAction.emit({key, value});
  }

  emitRowAction(row: any) {
    this.rowAction.emit(row);
  }

  emitPageChanged(data: any) {
    this.pageChanged.emit(data);
  }

  emitFilter(filterValue:string) {
    let query = filterValue.trim().toLowerCase();
    this.filter.emit(query);
    this.matPaginator.firstPage();
  }

  exportAction() {
    this.exportExcel.emit();
  }
  emitQueryParamFilter(queryParamFilter : any)
  {
    this.queryParamFilter.emit(queryParamFilter);
  }


}
